function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4479 20.8834V16.0499H28.9426C29.9648 16.0499 30.8276 15.7073 31.531 15.0318L31.6998 14.8605C32.9847 13.4619 32.9003 11.283 31.531 9.98895C30.8464 9.30389 29.9086 8.93281 28.9426 8.95184H24.938V20.8834H26.4479ZM26.448 14.5845V10.417H28.9805C29.5246 10.417 30.0405 10.6264 30.425 11.007C31.2411 11.8062 31.2599 13.1383 30.4719 13.9661C30.0874 14.3752 29.5433 14.6036 28.9805 14.5845H26.448Z",
  fill: "#3C4043"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.7432 13.3571C38.0961 12.7577 37.2145 12.4532 36.0985 12.4532C34.6636 12.4532 33.5851 12.9861 32.8723 14.0422L34.2041 14.889C34.6917 14.1659 35.3576 13.8043 36.2017 13.8043C36.7362 13.8043 37.2521 14.0042 37.6553 14.3657C38.0492 14.7082 38.2743 15.203 38.2743 15.7263V16.0784C37.6928 15.7549 36.9613 15.5836 36.061 15.5836C35.0106 15.5836 34.1665 15.831 33.5382 16.3353C32.9098 16.8396 32.591 17.5056 32.591 18.3524C32.5722 19.1231 32.9005 19.8557 33.4819 20.3505C34.0728 20.8833 34.823 21.1498 35.7046 21.1498C36.7456 21.1498 37.5709 20.6835 38.1993 19.7511H38.2649V20.8833H39.7092V15.85C39.7092 14.7939 39.3903 13.9566 38.7432 13.3571ZM34.6452 19.38C34.3356 19.1517 34.148 18.7806 34.148 18.381C34.148 17.9338 34.3544 17.5627 34.7577 17.2678C35.1704 16.9728 35.6863 16.8206 36.296 16.8206C37.1402 16.811 37.7968 17.0013 38.2658 17.3819C38.2658 18.0289 38.0125 18.5903 37.5154 19.066C37.0652 19.5228 36.4555 19.7797 35.8176 19.7797C35.3955 19.7892 34.9828 19.6464 34.6452 19.38Z",
  fill: "#3C4043"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9542 24.4704L47.9998 12.7196H46.3586L44.0234 18.5807H43.9952L41.6037 12.7196H39.9625L43.2731 20.36L41.3974 24.4704H42.9542Z",
  fill: "#3C4043"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2352 15.0033C21.2352 14.5371 21.1977 14.0708 21.1226 13.6141H14.7547V16.2497H18.4029C18.2528 17.0965 17.7651 17.8577 17.0524 18.3335V20.0461H19.2282C20.5037 18.8568 21.2352 17.0965 21.2352 15.0033Z",
  fill: "#4285F4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7549 21.7017C16.5744 21.7017 18.1122 21.0928 19.2282 20.0461L17.0524 18.3335C16.4428 18.7521 15.6646 18.99 14.7549 18.99C12.9918 18.99 11.5006 17.7816 10.9661 16.1641H8.72461V17.9339C9.86877 20.246 12.204 21.7017 14.7549 21.7017Z",
  fill: "#34A853"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9661 16.1641C10.6847 15.3173 10.685 14.3944 10.9664 13.538V11.7778H8.7246C7.75847 13.7093 7.75847 15.9928 8.7246 17.9243L10.9661 16.1641Z",
  fill: "#FBBC04"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7549 10.7121C15.7209 10.6931 16.6494 11.0642 17.3434 11.7397L19.2753 9.77968C18.0468 8.61888 16.4337 7.98138 14.7549 8.00041C12.204 8.00041 9.86877 9.46569 8.7246 11.7778L10.9661 13.5475C11.5006 11.9205 12.9918 10.7121 14.7549 10.7121Z",
  fill: "#EA4335"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 55,
  height: 31,
  rx: 5.5,
  stroke: "#DFE3E6"
});

function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.6a4e7f1b.svg";
export { ForwardRef as ReactComponent };